import React, { useState } from "react";
import { Drawer } from "@payping/web-components";

import HandlingCrispInMobile from "@/components/mobile/HandlingCrispInMobile";
import DrawerCloseButton from "@/components/Buttons/DrawerCloseButton";

interface Props {
  children?: React.ReactNode;
  title?: string;
}

const BottomSheetContainer: React.FC<Props> = (props) => {
  const [open, setOpen] = useState<boolean>(true);
  const { title, children } = props;

  return (
    <Drawer
      open={open}
      title={title}
      height="100%"
      closeIcon={false}
      placement="bottom"
      extra={<DrawerCloseButton setIsDrawerOpen={setOpen} />}
    >
      <HandlingCrispInMobile>{children}</HandlingCrispInMobile>
    </Drawer>
  );
};

export default BottomSheetContainer;
